import { render, staticRenderFns } from "./ResourcesIdEdit.vue?vue&type=template&id=2218e2b8"
import script from "./ResourcesIdEdit.vue?vue&type=script&lang=js"
export * from "./ResourcesIdEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports